import { render, staticRenderFns } from "./TvshowDetail.vue?vue&type=template&id=079cd072"
import script from "./TvshowDetail.vue?vue&type=script&lang=js"
export * from "./TvshowDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports